import { Divider, Grid, Stack } from '@mui/material'
import { EventDto } from '../../../../interfaces/IEvent'
import { EventStatus } from '../../../../interfaces/IEventEnums'
import { StatusChip } from '../../../../components/Chip/EventChip'
import { toDateTime } from '../../../../utils/ValueFormatters'
import AddContact from '../../ContactComponents/AddContact'
import ContactInfo from '../../ContactComponents/ContactInfo'
import DetailsContent, { contentNotSet, contentText, title } from '../DetailsContentGrid'
import AccessAlarmsOutlinedIcon from '@mui/icons-material/AccessAlarmsOutlined'
import TypographyWithUrl from '../../../../components/data-display/TypographyWithUrls'
import OverflowWrapper from '../../../../components/Wrapper/OverflowWrapper'

interface PlannedWorkDetailsProps {
  viewEvent: EventDto
  onUpdateEventView: (eventId: string) => void
}

export function GenericDetails({ viewEvent, onUpdateEventView }: PlannedWorkDetailsProps) {
  return (
    <Grid container direction="row" rowSpacing={1} sx={{
      alignItems: 'center'
    }}>
      <DetailsContent firstContent={title('Status')} lastContent={<StatusChip status={viewEvent.eventDetails.status as EventStatus} />} />
      <Divider flexItem sx={{ width: '100%' }} />
      <DetailsContent firstContent={title('Starttid')} lastContent={contentText(toDateTime(new Date(viewEvent.eventDetails.fromDate as Date)))} />
      <Divider flexItem sx={{ width: '100%' }} />
      <DetailsContent
        firstContent={title('Sluttid')}
        lastContent={
          viewEvent.eventDetails.toDate ? (
            <Stack
              direction="row"
              spacing={1}
              sx={{
                justifyContent: 'right',
                alignItems: 'center'
              }}>
              {viewEvent.eventDetails.status !== EventStatus.Lukket && new Date(viewEvent.eventDetails.toDate as Date) < new Date() && (
                <AccessAlarmsOutlinedIcon fontSize="small" color="warning" />
              )}
              {contentText(toDateTime(new Date(viewEvent.eventDetails.toDate as Date)))}
            </Stack>
          ) : (
            contentNotSet
          )
        }
      />
      <Divider flexItem sx={{ width: '100%' }} />
      <DetailsContent
        firstContent={title('Ansvarlig')}
        lastContent={
          viewEvent.eventDetails.responsible.name !== null && viewEvent.eventDetails.responsible.name !== ''
            ? contentText(viewEvent.eventDetails.responsible.name)
            : contentNotSet
        }
      />
      <Divider flexItem sx={{ width: '100%' }} />
      <DetailsContent
        firstContent={title('Ekst. referanse')}
        lastContent={viewEvent.eventDetails.externalReference.length > 0 ? contentText(viewEvent.eventDetails.externalReference) : contentNotSet}
      />
      <Divider flexItem sx={{ width: '100%' }} />
      <DetailsContent
        firstContent={
          <Stack direction={'row'} spacing={1} sx={{
            alignItems: 'center'
          }}>
            {title('Kontakter')}
            <AddContact viewEvent={viewEvent} onUpdateEventView={onUpdateEventView} />
          </Stack>
        }
        lastContent={
          viewEvent.contacts.length > 0 ? (
            <Stack
              direction={'row'}
              spacing={1}
              sx={{
                rowGap: 1,
                justifyContent: viewEvent.contacts.length > 1 ? 'left' : 'right',
                flexWrap: 'wrap'
              }}>
              {viewEvent.contacts.map((contact, index) => (
                <ContactInfo key={index} viewEvent={viewEvent} contact={contact} onUpdateEventView={onUpdateEventView} />
              ))}
            </Stack>
          ) : (
            contentNotSet
          )
        }
      />
      {viewEvent.eventDetails.description && (
        <>
          <Divider flexItem sx={{ width: '100%' }} />
          <DetailsContent
            firstContent={title('Beskrivelse')}
            lastContent={
              <OverflowWrapper maxHeight={600}>
                <TypographyWithUrl>{viewEvent.eventDetails.description}</TypographyWithUrl>
              </OverflowWrapper>
            }
            xs={12}
            lastContentAlign={'left'}
          />
        </>
      )}
    </Grid>
  );
}
